import React from "react";

const Footer = () => {
  return <div className="footer">Jones Tse 2022©</div>;
};

export default Footer;
